export default __webpack_public_path__ + "static/2-019a2025907d818a698179f57b822658.jpeg";